export const getSyiSlice = state => state.views.syi;
export const selectShortDescription = state =>
    getSyiSlice(state).shortDescription.shortDescription;
